import { render, staticRenderFns } from "./UQACreateEditModal.vue?vue&type=template&id=6b3e348b&"
import script from "./UQACreateEditModal.vue?vue&type=script&lang=js&"
export * from "./UQACreateEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports